export default '/pricing/tier-mobile/payment';
